export const PAGE_ADM_REPORTS = "/adm/reports";
export const PAGE_ADM_EXPORTS = "/adm/exports-in-queue";
export const PAGE_ADM_DRAFTS = "/adm/drafts";
export const PAGE_ADM_EDIT_REPORT = "/adm/reports/edit";
export const PAGE_ADM_NEW_REPORT = "/adm/reports/new";
export const PAGE_ADM_REPORT = "/adm/report";
